<template>
  <div class="is-border task" :class="{'is-grey has-text-grey': isRemoved, 'has-bg-white': !isRemoved}">
    <div class="over"></div>
    <div class="columns">
      <div class="column is-narrow is-margin-top-xsmall is-padding-top-small is-padding-bottom-xsmall">
        <span class="avatar">
          <span class="has-bg-optionne has-text-white">
            <i class="fas fa-bullhorn"></i>
          </span>
        </span>
      </div>
      <div class="column is-paddingless-left is-padding-top-small is-padding-bottom-xsmall">
        <p class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xsmall">
          <span v-if="isToday">Aujourd’hui à {{date | dtFormat('HH[h]mm')}}</span>
          <span v-else>{{date | prettyDatetime}}</span>
        </p>
        <p class="is-size-4">
          <strong>Dénonciation —
            <router-link :to="{name: 'LotVue', params: {id: denunciation.lot}}">{{denunciation.lot_ref}}</router-link>
          </strong>&nbsp;{{denunciation.program_name}}
        </p>
        <div class="columns is-gapless is-multiline">
          <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge is-size-6">
            <router-link :to="{name: 'UserVue', params: {id: denunciation.seller}}">
              <span class="has-text-grey">Vendeur :</span><br><span class="is-hover-underline">{{denunciation.seller_name}}</span>
            </router-link>
          </div>
          <div v-if="denunciation.company"
               class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge is-size-6">
              <router-link :to="{name: 'CompanyVue', params: {id: denunciation.company}}">
                <span class="has-text-grey">Société :</span><br><span class="is-hover-underline">{{denunciation.company_name}}</span>
              </router-link>
          </div>
          <div class="column is-12 is-narrow is-padding-top-xsmall is-padding-bottom-xsmall ">
            <router-link :to="{name: 'ContactVue', params: {id: denunciation.buyer}}" class="is-size-6">
              <span class="has-text-grey">Contact :</span>&nbsp;<span class="is-hover-underline">{{denunciation.buyer_name}}</span>
            </router-link>
            <div v-if="denunciation.duplicate_risk" class="is-margin-top-xsmall">
              <a @click="showDuplicates(denunciation)"
                class="button is-xsmall is-rounded tooltip is-danger"
                :data-tooltip="messages[denunciation.duplicate_risk - 1]">
                <!-- <span class="icon is-small" style="margin-top: -2px">
                  <i class="fas" :class="'fa-signal-alt-'+denunciation.duplicate_risk"></i>
                </span> -->
                <span class="is-transform-none">Doublon détecté</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                mode="out-in">
      <div v-if="isPending" key="buttons"
           class="column veryFastAnimation is-paddingless-top is-paddingless-bottom is-border-top is-border-dashed task-footer">
        <button @click="approve" class="button is-white is-size-7 is-height-4 is-min-width-0"
          :disabled="cardLoading">
          <span class="icon is-small"><i class="fas fa-check"></i></span>
          <span>Accepter</span>
        </button>
        <button @click="refuse" class="button is-white is-size-7 is-height-4 is-min-width-0"
          :disabled="cardLoading">
          <span class="icon is-small"><i class="fas fa-do-not-enter"></i></span>
          <span>Décliner</span>
        </button>
        <button @click="checkRisk" class="button is-white is-size-7 is-height-4 is-min-width-0"
          :disabled="cardLoading">
          <span class="icon is-small"><i class="fas fa-id-card-alt"></i></span>
          <span>Vérifier</span>
        </button>
      </div>
      <div v-else-if="!isPending && denunciation.updated_on" key="noButtons"
           class="column veryFastAnimation is-padding-top-small is-padding-bottom-small is-border-top task-footer has-bg-light-darken-1 is-border-top is-border-dashed has-text-grey is-size-6">
        <div class="is-min-width-0">
          Dénonciation <span v-if="isApproved">acceptée</span><span v-else>refusée</span>
          le {{denunciation.updated_on | prettyDatetime}}
          <span v-if="denunciation.update_author === currentUserPk">
          par vous.
        </span>
          <span v-else-if="denunciation.update_author_name">
          par {{denunciation.update_author_name}}
        </span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DenunciationCard',
    props: {
      denunciation: {
        type: Object,
        required: true
      }
    },
    components: {},
    data () {
      return {
        colors: ['is-optionne', 'is-warning', 'is-danger'],
        messages: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email'],
        cardLoading: false
      }
    },
    computed: {
      ...mapGetters(['currentUserPk']),
      isRemoved () {
        return !this.isPending && this.denunciation.updated_on
      },
      date () {
        return moment(this.denunciation.created_on)
      },
      isToday () {
        return this.date.isSame(moment(), 'day')
      },
      denunciationPk () {
        return this.denunciation.pk
      },
      status () {
        return this.denunciation.status
      },
      isApproved () {
        return this.status === 'approved'
      },
      isRefused () {
        return this.status === 'refused'
      },
      isPending () {
        return this.status === 'pending'
      }
    },
    methods: {
      approve () {
        this.cardLoading = true
        this.$api.denunciationService.patch(this.denunciationPk, {status: 'approved'}).then(r => {
          this.cardLoading = false
          this.$notify({
            type: 'is-success',
            text: 'Dénonciation acceptée'
          })
        })
      },
      refuse () {
        this.cardLoading = true
        this.$api.denunciationService.patch(this.denunciationPk, {status: 'refused'}).then(r => {
          this.cardLoading = false
          this.$notify({
            type: 'is-success',
            text: 'Dénonciation refusée'
          })
        })
      },
      checkRisk () {
        this.cardLoading = true
        this.$api.denunciationService.getDuplicate(this.denunciationPk).then(r => {
          this.cardLoading = false
          console.log(r.data.duplicates)
          if (r.data.duplicates.length > 0) {
            this.$notify({type: 'is-danger', text: 'Doublon trouvé'})
          } else {
            this.$notify({type: 'is-success', text: 'Aucun doublon trouvé'})
          }
        })
      },
      showDuplicates (denunciation) {
        this.$api.contactService.getOne(denunciation.buyer).then(r => {
          if (denunciation.duplicate_risk <= 2) {
            this.$router.push({name: 'ContactList', query: {first_name: r.data.last_name}})
          }
          if (denunciation.duplicate_risk === 3) {
            this.$router.push({name: 'ContactList', query: {email: r.data.email}})
          }
        })
      }
    },
    created () {
      this.$emit('process', this.denunciation)
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/event-card/DenunciationCard.vue